import { ChildBase, rootToken } from '../defaults';

export const loader: ChildBase = {
  spec: 'loader',
  token: 'main-loader',
  data: {
    visible: true,
    customData: {
      elevation: 0,
      container: rootToken,
    },
  },
  styles: {
    '& .MuiPaper-root': {
      background: 'transparent',
    },
    '& .MuiBackdrop-root': {
      background: 'rgba(255,255,255,0.6)',
    },
    position: 'absolute',
  },
};
